import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// CRM App
import CRMApp from "./crm/CRMApp";
import AdminApp from "./admin/AdminApp";
import OwnerApp from './owner/OwnerApp';
import {BrandingProvider,BrandedHome} from './branding/BrandingContext';
import { CRMAuthProvider } from './crm/context/CRMAuthContext';
import { StaffMFAGate } from './crm/components/MFAEnrollment';
import { routeStaffManagerRequest } from './services/staffManagerTransport';

// WebTrader App
import TraderApp from "./trader/TraderApp";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with interceptors
const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  if (window.location.pathname.startsWith('/admin/manager')) return routeStaffManagerRequest(config);
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.startsWith('/admin/manager')) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export { api, API, BACKEND_URL };

const StaffSessionBoundary = () => <CRMAuthProvider><StaffMFAGate><Outlet /></StaffMFAGate></CRMAuthProvider>;

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/owner/*" element={<OwnerApp />} />
          <Route path="/" element={<BrandedHome />} />
          {/* WebTrader Routes - Client-facing Trading Platform */}
          <Route path="/trader/*" element={<TraderApp />} />
          
          {/* CRM Routes - Separate Application */}
          <Route element={<StaffSessionBoundary />}>
            <Route path="/crm/*" element={<CRMApp />} />
            <Route path="/admin/*" element={<AdminApp />} />
          </Route>
          
          {/* The legacy manager UI (shared JWT login) is retired; the same
              screens are served by the 2FA-protected staff manager. */}
          <Route path="/login" element={<Navigate to="/admin/manager" replace />} />
          <Route path="/*" element={<Navigate to="/admin/manager" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default function BrandedApp(){return <BrandingProvider><App/></BrandingProvider>;}
